<template>
    <!-- <footer class="">
      <div class="container margin_60_35">
        
        <div class="row">
  
          <div class="col-lg-12 text-center">
          <span>Copyright © {{this.date}} eznatal. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer> -->
  
  
    <!-- footer begin -->
    <footer class="footer-light">
                  <div class="container">
                        <div class="row">
                            <div class="col-lg-5 col-md-6 col-sm-6 mb-3">
                                <div class="widget w-100">
                                    <a href="index.html" class=""><img alt="" class="logo w-50 mb-2"
                                            src="assets/img/eznatal-logo-final-bnw.png"></a>
                                    
                                    <!--<h5>For Birth Centers </h5>
                                      <p>Manage classes, tours, webinars, support groups, breast pump rentals and library memberships CX
                                    </p> -->
                                </div>
                            </div>
                        </div>
                      <div class="row justify-content-between">  
                          <div class="col-lg-2 col-md-3 col-sm-3">
                              <div class="widget">
                                  <h5>Resources</h5>
                                  <ul>
                                      <li><router-link to="/support-request">Support Request</router-link></li>
                                      <li><router-link to="/blog">Blog</router-link></li>
                                      <li><router-link to="/faq">FAQ</router-link></li>
                                      <li><router-link to="/release">Release Note</router-link></li>
                                  </ul>
                              </div>
                          </div>
                          <div class="col-lg-2 col-md-3 col-sm-3">
                              <div class="widget">
                                  <h5>Company</h5>
                                  <ul>
                                      <li><a href="https://eznatal.com/about-us.html" target="_blank">About</a></li>
                                      <li><a href="https://eznatal.com/press.html" target="_blank">Press</a></li>
                                      <li><a href="https://eznatal.com/contact.html" target="_blank">Contact</a></li>
                                  </ul>
                              </div>
                          </div>

  
                          <div class="col-lg-4 ">
                              <div class="widget subscribe">
                                  <h5>Subscribe</h5>
                                  <p class="">Sign up to get news alerts, behind-the-scenes insights, and research from eznatal News & Insights</p>
                                  <div class=" my-3">
                                      <input id="subscribe-email" ref="emailInput" type="email" class="form-control" placeholder="Enter your email" aria-label="Email" aria-describedby="subscribe-email" v-model="subscribeWithEmail.Email">
                                      <div v-if="this.subscribeWithEmail.Email!=='' && isValidEmail===false" class="text-danger">Please insert a valid email</div>
                                  </div>
                                  <div class="input-group-append">
                                        <button :disabled="isValidEmail===false" class="btn-lg btn btn-danger" type="button" id="submit-subscribe-email" @click="subscribe">Subscribe </button>
                                </div>
                              </div>
                          </div>
                      </div>
  
                      <div class="row">
                        <div class=" ml-3 social-icons">
                         <div class="widget">
                            <a href="https://www.facebook.com/eznatal/" target="_blank" ><i class="fa fa-facebook fa-lg ml-0"></i></a>
                            <a href="https://twitter.com/eznatal" target="_blank" ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                            <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"/>
                            </svg></a>
                        
                           <a href= "https://www.linkedin.com/company/eznatal/" target="_blank" ><i class="fa fa-linkedin fa-lg" ></i></a>
                           <a href="https://www.instagram.com/ez.natal" target="_blank"><i class="fa fa-instagram fa-lg"></i></a>
                           <a href="https://www.youtube.com/channel/UCLViupKHl5aT-SE08t_4-Ng" target="_blank"><i class="fa fa-play fa-lg"></i></a>
                         </div>
                        </div>

                          <div class="col-md-12 ">
                              <div class="social-icons">
                                  <a href="http://35.192.231.16/eznatal/terms.html" class="mr-2"> <u>Terms</u></a>
                                  <a href="http://35.192.231.16/eznatal/privacy.html" class="mr-2"><u>Privacy</u></a>  
                                  <a href="#" class="mr-2"><u>Cookie Declaration</u></a>
                                  <a class="ml-2">&copy; 2023 - eznatal- A project of in-school.com inc. All rights reserved</a>
                              </div>
                          </div>
                      </div>
                  </div>
              </footer>
              <!-- footer close -->
  
    
    <!--/footer-->
  </template>
<script>
import SubscriberService from '../../services/subscriber'
export default {
  name: 'Footer',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      date: new Date().getFullYear(),
      subscribeWithEmail: { Email: '', Resource:'All' },
      msg: [],
    }
  },
  computed: {
    isValidEmail() {
      return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(this.subscribeWithEmail.Email)
    }
  },
  methods:{
    subscribe() {
      // this.CategoryId = this.selectedCategory.Id
      // this.isValidateFields()
      console.log(this.subscribeWithEmail)
      SubscriberService.subscribeWithEmail(this.subscribeWithEmail).then(
        (response) => {
          console.log(response)
          if (response.data.Status) {
            alert('Thank you for subscribing!', 'success')
            this.$refs.emailInput.value = null
          }
          else{
            alert(response.data.Message, 'danger')
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
  }
}
</script>
  